<template>
    <b-col class="animated fadeIn" sm="6">
        <b-card>
            <b-form @submit="save">
                <b-form-group
                    :label="$t('emails')"
                    label-for="emails"
                    :description="$t('enterEmailsSeparatedByComma')"
                    :label-cols="12">
                    <v-select
                        id="emails"
                        v-model="model.emails"
                        noDrop
                        taggable
                        multiple
                        :map-keydown="mapEmailKeys"
                        :create-option="email => email.trim()" />
                </b-form-group>

                <SelectField name="Role" :label="this.$t('role')" v-model="model.role_uuid" @error="fieldError"
                    :multiple="true" :items="roles" :rules="{ required: true }" />

                <InputField type="text" name="subject" :label="this.$t('subject')" v-model="model.subject"
                    @error="fieldError" :rules="{ required: false, length: { min: 5 }, placeholder:'You have been invited to join an awesome project' }" />

                <InputField type="text" name="comment" :label="this.$t('comment')" v-model="model.comment"
                    @error="fieldError" :rules="{ required: false, length: { min: 5 } }" />


                <div class="d-flex justify-content-end mt-3">
                    <b-button type="submit" variant="success" class="px-4">
                        <b-icon icon="envelope" class="mr-2"></b-icon>
                        {{ $t('sendInvites') }}
                    </b-button>
                </div>
            </b-form>
        </b-card>
    </b-col>
</template>

<script>
import Input from "@/components/form/Input"
import Select from "@/components/form/Select"
import vSelect from 'vue-select'

export default {
    name: "Create",
    components: {
        InputField: Input,
        SelectField: Select,
        vSelect
    },
    data: function () {
        return {
            errors: [],
            model: {
                emails: [],
                role_uuid: [],
                subject: "",
                comment: ""
            }
        }
    },

    computed: {
        items() {
            let project = this.$store.getters.getCurrentProject
            let users = []

            if (project.users !== undefined) {
                project.users.forEach(user => {
                    users.push(user.User)
                });
            }

            return users
        },

        roles() {
            let roles = this.$store.getters.getRoles
            roles.map(el => {
                el.text = el.name
                el.value = el.uuid
            })

            return roles
        }
    },
    methods: {
        save(e) {
            e.preventDefault()

            if (this.model.emails.length === 0) {
                this.$mainDialog.msgBoxOk(this.$t('fieldsNotValid'))
                return
            }

            if (this.checkForErrors()) {
                this.$mainDialog.msgBoxOk(this.$t('fieldsNotValid'))

                return
            }

            this.$http.post("/v2/project/invite", {
                ...this.model,
            }).then(() => {
                this.$bvToast.toast(this.$t('invitationsSent'), {
                    variant: 'success',
                    title: "Success"
                })

                this.$router.push({ path: "/admin/iam" })
            }).catch(err => {
                if (err.response.status == 500) {
                    this.$serverErrorModal(err)
                    return
                }

                this.$mainDialog.msgBoxOk(err.response.data.message)
            })
        },

        fieldError(error) {
            let found = this.errors.find((i) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i) => {
                return i.error
            })
        },

        mapEmailKeys(map, vm) {
            return {
                ...map,
                188: function (e) {
                    e.preventDefault()
                    vm.typeAheadSelect()
                }
            }
        },
    },
    mounted() {
        this.$store.dispatch("fetchRoles").catch(error => {
            if (error.response.status == 500) {
                this.$serverErrorModal(error)
                return
            }

            this.$mainDialog.msgBoxOk(error.response.data.message)
        })
    }
}
</script>
